module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_EL-c9c61cba06004994a2d75eff2acb4da8.svg";